import React from "react";
import pieChart from "../assets/pieChart.png";
import MarginBottom from "./MarginBottom";

const Distribution = () => {
  return (
    <>
      <h2 className="text-3xl text-center sm:text-left my-10 sm:text-4xl sm:my-5 text-lyellow px-[2.3em] font-semibold">
        Distribution
      </h2>
   
    <div className="flex justify-center my-5">
        <div className="">
            <div className="block p-6 w-[24em] sm:w-[35em] bg-black/40 rounded-2xl border border-black/80 shadow-md mb-10 cursor-pointer">
              
              <div className="w-full flex justify-center items-center mb-10">
                  <img src={pieChart} alt="" />
              </div>
                
              <div className="flex justify-between">
                  <div className="flex flex-col justify-center items-start">
                    <h3 className="text-lyellow font-bold">DIGITS and STAR MATCHED</h3>
                    <div className="flex items-center my-2">
                      <span className="bg-[#D750B2] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">5 Numbers + 2 Stars</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#A881FC] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">5 Numbers + 1 Stars</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#85C54E] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">5 Numbers</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#36E8F5] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">4 Numbers</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#028E75] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">3 Numbers</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#FFE362] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">2 Numbers</p>
                    </div>
                    <div className="flex items-center my-2">
                      <span className="bg-[#BDC2C4] rounded-full w-5 h-5 mr-2"></span>{" "}
                      <p className="text-white text-sm">For Maintenance & Stake Holders</p>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-end">
                    <h3 className="text-lyellow  font-bold">
                      <span className="relative left-16 bottom-2 sm:left-0 sm:bottom-0">PRIZE POOL ALLOCATION</span>
                    </h3>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">40%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">20%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">10%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">5%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">3%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">2%</p>
                    </div>
                    <div className="flex items-center my-2">
                      <p className="text-white text-sm">20%</p>
                    </div>
                  </div>
              </div>
              

            </div>
          </div>
    </div>
     

      <MarginBottom />
    </>
  );
};

export default Distribution;
